import styled from "styled-components"

import { maxWidth } from "utils"

import NetworkAd from "components/network-ad"

export const Container = styled.aside`
  position: relative;
  width: 30rem;
  min-width: 30rem;
  background: #f9f9f9;

  ${maxWidth.rightRail`
    display: none;
  `}
`

export const AdSlot = styled.div`
  position: relative;
  height: ${(props) => props.height}px;
  padding-bottom: 10px;
  visibility: ${(props) => (props.visible ? "visible" : "hidden")};
  z-index: 1;
`

export const SignUpSlot = styled.div`
  position: relative;
  height: ${(props) => props.height}px;
  padding-bottom: 10px;
  z-index: 2;
`

export const RightRailAd = styled(NetworkAd)`
  position: sticky;
  top: 10rem;
  left: 0;
  width: 100%;
  float: left;

  &:first-of-type {
    margin-top: 2rem;
  }
`
